const mainNavigation = {
  el: {
    root: document.querySelector<HTMLElement>('.main-navigation'),
    items: document.querySelectorAll<HTMLButtonElement>('.main-navigation__button'),
  },
  init() {
    this.navClick()
  },
  navClick() {
    this.el.items.forEach(async (item) => {
      item.addEventListener('click', async (e: Event & { target: HTMLButtonElement }) => {
        if (document.querySelector('.header__offices-drop.open')) {
          document.querySelector('.header__offices-drop.open').classList.remove('open')
          document.querySelector('.header__office-button.co-trigger').setAttribute('aria-expanded', 'false')
        }

        if (
          document.querySelector('.main-navigation__drop.open') &&
          document.querySelector('.main-navigation__drop.open') !==
            document.querySelector(`.main-navigation__drop.open[data-nav="${e.target.dataset.nav}"]`)
        ) {
          document.querySelector<HTMLElement>('.main-navigation__drop.open').classList.remove('open')
        }

        document.querySelector(`.main-navigation__drop[data-nav="${e.target.dataset.nav}"]`).classList.toggle('open')
        this.ariaReset()
        e.target.setAttribute('aria-expanded', 'true')
      })
    })
  },

  ariaReset() {
    this.el.items.forEach((item) => {
      item.setAttribute('aria-expanded', 'false')
    })
  },
}

export default mainNavigation
